import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import { COLORS } from '../commonComponents/COLORS';

  
export const PhoneNumber = styled("div")({
    backgroundColor: COLORS.purpleColor,
    color: "#fff",
    padding: "10px 0",
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    position: "absolute",
    bottom: 0,
  });

export const AnimatedCard = styled(Card)({
    maxWidth: 250,
    margin: "auto",
    textAlign: "center",
    boxShadow: "none",
    position: "relative",
    overflow: "hidden",
    transition: "transform 0.3s ease",
  
    "&:hover": {
      transform: "scale(1.05)",
    },
  
    "&:hover .overlay": {
      top: 0,       // Moves overlay upward
      left: 0,      // Moves overlay from left side
      opacity: 1,   // Ensures the overlay appears gradually
    },
  });
  
  export const Overlay = styled("div")({
    position: "absolute",
    top: "100%",   // Initially positioned below
    left: "-100%", // Initially positioned off to the left
    width: "100%",
    height: "100%",
    backgroundColor: COLORS.overlayColor,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0, // Hidden by default
    transition: "top 0.4s ease, left 0.4s ease, opacity 0.4s ease", // Smooth transitions
  });
  
  export const IconWrapper = styled("div")({
    display: "flex",
    gap: "15px",
    justifyContent: "center",
    "& svg": {
      color: COLORS.pinkColor,
      fontSize: "30px",
      border: `2px solid ${COLORS.pinkColor}`,
      borderRadius: "50%",
      padding: "10px",
      transition: "transform 0.3s ease, background 0.3s ease",
      "&:hover": {
        transform: "scale(1.1)",
        background: "#fff",
        color: COLORS.pinkColor,
      },
    },
  });
  